export default __webpack_public_path__ + "static/media/signout-btn.3a2c3478.svg";